import { SpinAndHoldCommonConfiguration } from "../../../api";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { SpinAndHold2 } from "../SpinAndHold/SpinAndHold2";
import { SpinAndHold2Params } from "../SpinAndHold/SpinAndHold2Params";

export class ExtendedSpinAndHold2_2Screens extends SpinAndHold2 {
	protected override BonusName(): string {
		return "ExtendedSpinAndHold";
	}

	//protected remainingSpinsCanvas: MyCanvas = null;
	//protected ctxWremainingSpinsCanvas: MyCanvasContext = null;

	public constructor(gameResid: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration) {
		super(gameResid, params, config);
	}
}

export interface IExtendedSpinAndHoldBonusFactory2_2Screen {
	CreateExtendedSpinAndHold2_2Screen(gameName: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration): SpinAndHold2;
}



export class ExtendedSpinAndHoldBonusFactory2_2Screen  implements IExtendedSpinAndHoldBonusFactory2_2Screen {

	public CreateExtendedSpinAndHold2_2Screen(gameName: ResourceIdentifier, params: SpinAndHold2Params, config: SpinAndHoldCommonConfiguration): SpinAndHold2 {
		return new ExtendedSpinAndHold2_2Screens(gameName, params, config);
	}
}